import { render, staticRenderFns } from "./global_no_access.vue?vue&type=template&id=af4db6ba&"
import script from "./global_no_access.vue?vue&type=script&lang=js&"
export * from "./global_no_access.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports